/* ============================================================
   Product Card v2 — hover-video playback service (dormant)

   CSS cannot start media loading: with preload="none", Chrome
   never dispatches the fetch until an explicit load()/play()
   call (verified 2026-07-27 — networkState stays LOADING with
   zero network requests, even when the element is rendered).
   This script services only the hover that
   assets/product-card-v2.css already styles: play on image
   hover of a v2 card, pause on leave.

   No init call, no observers — adding the `pgi-v2` class to the
   grid container (section setting or Intelligems) remains the
   whole activation contract; without it this file does nothing.
   ============================================================ */
(function () {
  'use strict';
  if (window.__pgiV2VideoLoaded) return; // section may render this tag on multiple templates
  window.__pgiV2VideoLoaded = true;

  var reduced =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function videoFor(target) {
    if (!target || target.nodeType !== 1 || !target.matches) return null;
    if (!target.matches('.pgi-v2 > .product-grid-item .grid__image--primary')) return null;
    var image = target.closest('.grid__image');
    return image ? image.querySelector('.grid__image--secondary.is-video video') : null;
  }

  // mouseenter/mouseleave don't bubble — capture-phase delegation.
  document.addEventListener(
    'mouseenter',
    function (e) {
      if (reduced) return; // CSS hides the overlay too
      var video = videoFor(e.target);
      if (!video) return;
      video.removeAttribute('controls'); // native controls render on a paused video
      video.removeAttribute('autoplay'); // see load() note below
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      if (video.readyState === 0 && !video.__pgiV2Kicked) {
        // Chromium quirk: the parse-time autoplay attr starts resource
        // selection for the preload="none" video and then SUSPENDS it;
        // play() alone waits on that suspended fetch forever (verified:
        // no network request ever dispatches). A one-time load() restarts
        // the fetch for real; play() below then starts as data arrives.
        video.__pgiV2Kicked = true;
        try { video.load(); } catch (err) { /* noop */ }
      }
      try { video.currentTime = 0; } catch (err) { /* before metadata: fine */ }
      var p = video.play();
      if (p && p.catch) p.catch(function () { /* autoplay blocked: static image stays */ });
    },
    true
  );

  document.addEventListener(
    'mouseleave',
    function (e) {
      var video = videoFor(e.target);
      if (!video) return;
      try { video.pause(); } catch (err) { /* noop */ }
    },
    true
  );
})();
